import { Service } from "typedi";

// v1 dev: hardcoded until the MITM appliance injects identity from the network layer.
@Service()
export class StudentEmailManager {
    private static readonly EMAIL = "test@network.local";

    async getEmail(): Promise<string | undefined> {
        return StudentEmailManager.EMAIL;
    }

    setEmail(_email: string): void {}

    clear(): void {}
}
